<template>
    <Layout is-crm>
        <iframe
            v-if="order && order.remote_file_link"
            width="100%"
            height="1000px"
            :src="order.remote_file_link"
            frameborder="0"
        ></iframe>
    </Layout>
</template>

<script>
import { fetchOrder } from '../../api/orders';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

export default {
    name: 'OrderEditDocumentPage',
    components: {
        Layout,
    },

    data() {
        return {
            loading: false,
            order: undefined,
        };
    },

    computed: {
        orderRoute() {
            const { id } = this.$route.params;
            return {
                name: 'orders-id',
                params: { id },
            };
        },
    },

    async created() {
        this.loading = true;
        try {
            this.order = await fetchOrder(this.$route.params.id);
        } catch (e) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    },
};
</script>
